(() => {
  if (window.__oneMoreBound) return;
  window.__oneMoreBound = true;
  const root = window.Shopify?.routes?.root ?? '/';

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-one-more-add]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;

    const card = btn.closest('.one-more__card');
    const prevError = card?.nextElementSibling;
    if (prevError && prevError.classList.contains('one-more__error')) prevError.remove();

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
          sections: sectionIds,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || `HTTP ${res.status}`);

      const cart = await fetch(`${root}cart.js`).then((r) => r.json());

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'one-more',
            data: { source: 'one-more', itemCount: cart.item_count, sections: data.sections },
          },
        })
      );

      card?.remove();
    } catch (err) {
      console.error('[one-more]', err);
      btn.disabled = false;
      if (card) {
        const msg = document.createElement('p');
        msg.className = 'one-more__error';
        msg.textContent = err.message;
        card.after(msg);
      }
    }
  });
})();